
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzButton from "@/models/MiezzButton";
import MiezzForm from "@/models/MiezzForm";
import MiezzModal from "@/models/MiezzModal";
import ParamChargeUnitAppService from "@/apis.machine/ParamChargeUnitAppService";
import DtoFormParamChargeUnit, {
  DtoFormParamChargeUnitMiezzFormItems,
  DtoFormParamChargeUnitRules,
} from "@/models.machine/DtoFormParamChargeUnit";

export default class ParamChargeUnitForm extends Vue {
  @Model() modelValue!: MiezzModal;
  @Prop() id?: string;

  form = new MiezzForm<DtoFormParamChargeUnit, string>();
    NameZhList: string[] = [];

  created(): void {
    //表单-数据-初始化
    this.form.Data = new DtoFormParamChargeUnit();
    //表单-校验
    this.form.Rules = DtoFormParamChargeUnitRules;
    this.form.Rules.NameZh = [
      {
        required: true,
        message: "信息不能为空",
        trigger: "blur",
      },
      {
        required: true,
        validator: (rule: any, value: string, callback: any) => {
          if (this.form.Data.NameZh != null && typeof (this.form.Data.NameZh) != "undefined" && this.form.Data.NameZh != "undefined" && this.form.Data.NameZh != "") {
            var NameZh = this.form.Data.NameZh.trim();
            if (this.NameZhList.some(it => it == NameZh)) {
              callback(new Error("信息重复，请重新填写"));
              return false;
            } else {
              return callback();
            }
          }
          else {
            return callback();
          }
        },
        trigger: "blur",
      },
    ];
    //表单-元素配置
    this.form.Items = DtoFormParamChargeUnitMiezzFormItems;

    //修改元素配置
    //for (const item of this.form.Items) {
    //  switch (item.Prop) {
    //    default:
    //      break;
    //  }
    //}

    this.modelValue.HandleClick = this.handleClick;
    this.modelValue.Buttons = [
      {
        Code: "submit",
        Label: "保存",
        Type: "primary",
        Size: "small",
      },
    ];

    this.handleGet();
  }

  /**查询表单数据 */
  handleGet(): void {
    ParamChargeUnitAppService.GetNameZhList().then((r1) => {
      if (r1.data.Data) this.NameZhList = r1.data.Data;

      if (this.id) {
        ParamChargeUnitAppService.GetById(this.id).then((r) => {
          if (r.data.Data) {
            this.form.Data = r.data.Data;

            var index = this.NameZhList.findIndex(it => { return it == this.form.Data.NameZh });
            this.NameZhList.splice(index, 1);
          }
        });
      }
    })
  }

  /**按钮点击 */
  handleClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      case "submit":
        MiezzForm.submit(this.$refs, "ruleForm", (v) => {
          if (v) {
            ParamChargeUnitAppService.Post(this.form.Data)
              .then(() => {
                this.handleSubmit();
                complete();
              })
              .catch(complete);
          } else complete();
        });
        break;
      default:
        break;
    }
  }

  onBlurNameEn(): void {
    if (this.form.Data.NameEn) {
      this.form.Data.NameEn = this.form.Data.NameEn.toUpperCase();
    }
  }

  /**表单提交-回调 */
  @Emit()
  handleSubmit(): void {
    //
  }
}
